import { useContext } from 'react';
import type { IMediaContext } from '../components/MediaProvider/MediaContext';
import MediaContext from '../components/MediaProvider/MediaContext';

export default function useMedia(): IMediaContext {
  return useContext(MediaContext);
}
